import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

const DEFAULT_DEV_API_URL = 'http://localhost:3004';

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL =
    baseURL ||
    BizAppConfig.appApiUrl ||
    (process.env.NODE_ENV === 'development' ? DEFAULT_DEV_API_URL : '');
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
